"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./TeamBadge.scss");
const TeamBadge_scss_json_1 = __importDefault(require("./TeamBadge.scss.json"));
const react_2 = require("@tolgee/react");
const TeamBadge = ({ medalImage, medalNumber, medalDescription, }) => {
    const { t } = (0, react_2.useTranslate)();
    return (react_1.default.createElement("div", { className: TeamBadge_scss_json_1.default.container },
        react_1.default.createElement("div", { className: TeamBadge_scss_json_1.default.title },
            react_1.default.createElement("img", { src: medalImage, alt: "medal" }),
            react_1.default.createElement("h1", null, medalNumber)),
        react_1.default.createElement("div", { className: TeamBadge_scss_json_1.default.description },
            react_1.default.createElement("p", null, t('medal.' + medalDescription, medalDescription)))));
};
exports.default = TeamBadge;
//# sourceMappingURL=TeamBadge.js.map